import React, { useEffect, useState } from 'react'
import {
  Main,
  Header,
  useGlobalAudio,
} from '@orbital/games-frontend-library'
import { HoldemWrapper } from './HoldemStyled'
import GameBoard from '../components/gameBoard/GameBoard'
import Footer from '../components/footer/Footer'
import { GAME_PROPS } from './interfaces'
import clearCards from './helpers/clearCards'
import useSliceCards from './helpers/sliceCard'
import dealRaise from './helpers/dealRaise'
import useWinCombinations from './helpers/getWinCombination'
import useBalanceUpdate from './helpers/updateBalance'

export default function Game({
  blur,
  gameInfo,
  audio,
  colors,
  stateRound,
  handleAbove,
  handleNotification,
  handleDeal,
  handleRaise,
  handleFold,
  stakesForSocket,
  showLoader,
  isError,
}: GAME_PROPS) {
  const SFXS = useGlobalAudio(audio.volume, audio.sound)
  const {
    balance,
    cards,
    state,
    playerWinPositions,
    dealerWinPositions,
    playerWinType,
    dealerWinType,
  } = stateRound

  const [dealer, setDealer] = useState<string[]>(['X0', 'X0'])
  const [river, setRiver] = useState<string[]>(['X0', 'X0', 'X0', 'X0', 'X0'])
  const [player, setPlayer] = useState<string[]>(['X0', 'X0'])

  const [isFolded, setIsFolded] = useState<boolean>(false)
  const handleIsFolded = (b: boolean) => setIsFolded(b)

  useSliceCards(cards, setPlayer, setRiver, setDealer)

  const [flipCard, setFlipCard] = useState<boolean>(false)
  const [dealRiver, setDealRiver] = useState<boolean>(false)
  // const [error, setError] = useState<boolean>(false)

  const [gameState, setGameState] = useState<number>(state)
  // const [dealRiseState, setHandleDealRaise] = useState(false)

  const handleNewBet = () => setGameState(0)

  const { winCombination, winType } = useWinCombinations(
    gameState,
    playerWinPositions,
    dealerWinPositions,
    playerWinType,
    dealerWinType,
  )

  useEffect(() => {
    setGameState(state)
    switch (state) {
      case 4:
        handleCardDeal(true)
        setIsFolded(false)
        setTimeout(() => {
          setShowResult(true)
        }, 2100)
        break
      case 5:
      case 11:
        handleDealRaise()
        setIsFolded(false)
        break
      case 6:
        !isFolded && handleDealRaise()
        break
      default:
        break
    }
  }, [state])

  useEffect(() => {
    isError && gameState !== 4 && setGameState(0)
  }, [isError, gameState])

  const [deal, setDeal] = useState<boolean>(false)
  const handleCardDeal = (b: boolean) => setDeal(b)

  const [dealOut, setDealOut] = useState<boolean>(false)
  const handleDealOut = (b: boolean) => setDealOut(b)

  const [showResult, setShowResult] = useState<boolean>(false)
  const handleShowResult = (b: boolean) => setShowResult(b)

  const finalBalance = useBalanceUpdate(stateRound, showResult)

  const handleClearCards = (delay: number) => {
    clearCards(
      setPlayer,
      setRiver,
      setDealer,
      handleDealOut,
      handleCardDeal,
      setFlipCard,
      setDealRiver,
      delay,
    )
  }
  const handleDealRaise = () => {
    dealRaise(setDealRiver, setFlipCard, handleShowResult)
  }
  return (
    <Main blur={blur}>
      <HoldemWrapper>
        <Header
          title='CASINO'
          gameInfo={gameInfo}
          colors={colors}
          handleAbove={handleAbove}
          sfx={SFXS.goForwardSFX}
          fontSize='24px'
          betInfoBalance={finalBalance}
          balanceUpdateOn='now'
        />
        <GameBoard
          deal={deal}
          dealOut={dealOut}
          showResult={showResult}
          dealer={dealer}
          player={player}
          river={river}
          dealRiver={dealRiver}
          flipCard={flipCard}
          audio={audio}
          gameState={gameState}
          winPositions={winCombination}
          showLoader={showLoader}
        />
        <Footer
          gameInfo={gameInfo}
          handleNotification={handleNotification}
          handleDeal={handleDeal}
          handleRaise={handleRaise}
          handleFold={handleFold}
          handleNewBet={handleNewBet}
          handleDealOut={handleDealOut}
          showResult={showResult}
          currency={gameInfo.currency}
          gameState={gameState}
          stateRound={stateRound}
          stakesForSocket={stakesForSocket}
          deal={deal}
          audio={audio}
          handleClearCards={handleClearCards}
          handleShowResult={handleShowResult}
          isError={isError}
          winType={winType}
          isFolded={isFolded}
          handleIsFolded={handleIsFolded}
          dealOut={dealOut}
        />
      </HoldemWrapper>
    </Main>
  )
}
